/**
 * HTML Editor
 * Handles configuration for html display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for html control
 */
function renderHtmlEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          HTML Content
          <textarea
            value={(control.config?.html as string) || ''}
            onChange={(e) => onConfigChange('html', e.target.value)}
            className="af-properties-tab__textarea"
            rows={6}
            placeholder="<p>Enter HTML here</p>"
          />
        </label>
      </div>
    </div>
  );
}

/**
 * HtmlEditor - Handles html control configuration
 */
export const HtmlEditor: PropertyEditor = {
  type: 'html',
  label: 'HTML',
  description: 'Configure HTML content for display',
  render: renderHtmlEditor,
};
